import React, { useState } from 'react';
import { PAGE_TYPES } from '../enums/page-types';
import Button from '../components/Button';
import useCheckoutState from '../hooks/useCheckoutState';
import { checkoutTypes } from '../enums/checkout-types';
import { isProduction } from '../services/env';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function TemplateDialog() {
  const { page, seller, checkoutType, isPreview, isTestingPayments } = useCheckoutState();
  const [isOpen, setIsOpen] = useState(true);

  if (!isProduction || isPreview || isTestingPayments) {
    return null;
  }

  if (checkoutType !== checkoutTypes.CHECKOUT) {
    return null;
  }

  let isTemplatesAccount = false;
  if (
    seller.name === 'templates' ||
    seller._id === '6581eb4d8275107f82cbeb1f' || // templates account
    seller._id === '6228270053f586d3a7429e87' || // local templates account
    seller._id === '6183a31cd81f5ea65eb3a11f' || // Andy's account
    seller._id === '64e459747176a44b90afa533' // Sander's account
  ) {
    isTemplatesAccount = true;
  }

  if (!isTemplatesAccount) {
    return null;
  }

  const startFromTemplateUrl = `${process.env.NEXT_PUBLIC_APP_URL}/dashboard/pages/create?page=${
    page._id
  }&title=${page.productTitle || page.title}&type=${page.type}`;

  return (
    <div
      className={clsx(
        'fixed bottom-4 left-4 z-50 bg-white drop-shadow-xl rounded-lg p-4 max-w-sm',
        {
          hidden: !isOpen,
        },
      )}
    >
      <h3 className="text-lg !font-semibold mb-3 text-center">
        {page.type === PAGE_TYPES.EVENT && 'Want this event?'}
        {page.type === PAGE_TYPES.CHECKOUT && 'Want this checkout page?'}
        {page.type === PAGE_TYPES.FORM && 'Want this form?'}
      </h3>

      <Button
        className="bg-neutral-900 hover:bg-neutral-900/90 !text-white !text-sm !font-medium w-full !text-center items-center justify-center"
        to={startFromTemplateUrl}
      >
        Copy template
      </Button>

      <button
        onClick={() => setIsOpen(!isOpen)}
        className="absolute -top-2.5 -right-2.5 bg-white rounded-full p-1 shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-200"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
